/**
 * Builds a Kaleidoscope path for a Rails admin page that will be rendered in an
 * iframe via AdminLegacyPage. Paths under /admin/* or /super_admin/* pass
 * through; others get a /r/ prefix to avoid conflicts with existing Kaleidoscope
 * routes.
 */
export const adminIframePath = (railsPath: string, shell: '/admin' | '/super_admin' = '/admin'): string => {
	const normalized = railsPath.startsWith('/') ? railsPath : `/${railsPath}`;
	if (normalized.startsWith('/admin/') || normalized.startsWith('/super_admin/')) return normalized;
	return `${shell}/r${normalized}`;
};
